<template>
  <v-dialog
    :value="value"
    width="600"
    @click:outside="closeDialog"
  >
    <v-card>
      <v-card-title class="justify-space-between third white--text">
        Selecionez un cheval pour {{ participant.fullname }}
        <v-btn icon @click="closeDialog">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="card-body ">
        <div v-if="loading" class="d-flex justify-center align-center">
          <Loader />
        </div>
        <v-select
          v-else
          v-model="selectedHorse"
          :items="horses"
          item-text="horse_name"
          item-value="uuid"
          label="Cheval"
          return-object
        />
      </v-card-text>
      <v-divider />
      <v-card-actions class="justify-end">
        <v-btn
          class="white--text"
          small
          rounded
          color="third"
          :disabled="!selectedHorse || loading"
          @click="addWithHorse"
        >
          <v-icon size="16" right>mdi-horse-human</v-icon>
          Ajouter avec cheval
        </v-btn>
        <v-btn class="white--text" small rounded color="third" :disabled="loading" @click="addWithoutHorse">
          <v-icon size="16" right>mdi-account</v-icon>
          Ajouter sans cheval
        </v-btn>
        <v-btn class="white--text" small rounded color="third" :disabled="loading" @click="closeDialog">
          <v-icon size="16" right>mdi-close</v-icon>
          Annuler
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref } from '@vue/composition-api';
import Loader from '@/components/common/Loader.vue';


export default {
  components: {
    Loader
  },
  props: {
    participant: {
      type: Object,
      default: () => ({})
    },
    horses: {
      type: Array,
      default: () => []
    },
    value: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    const selectedHorse = ref(null);

    const closeDialog = () => {
      emit('close-dialog');
    };

    const addWithoutHorse = () => {
      emit('add-without-horse', false, null);
    };

    const addWithHorse = () => {
      emit('add-with-horse', true, selectedHorse.value);
    };

    return { selectedHorse, closeDialog, addWithoutHorse, addWithHorse };
  }
};
</script>
